var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c(
        "form",
        {
          attrs: {
            autocomplete: "off",
            method: "post",
            disabled: _vm.loading,
            "data-vv-scope": _vm.vScope,
          },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return (() => {}).apply(null, arguments)
            },
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onBeforeSaveItem.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-sm-auto" }, [
              _c("h1", { staticClass: "content-title" }, [
                _vm._v(_vm._s(_vm.titleItem)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: _vm.isLayer },
                          expression: "{required: isLayer}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-layer_id",
                        name: "layer_id",
                        label: "name",
                        filterable: true,
                        options: _vm.groups,
                        indentText: true,
                        indentationTarget: "layer_id",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              "layer_id",
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError("layer_id", _vm.vScope),
                        helpText: `${_vm.helpTranslateID}.group`,
                      },
                      model: {
                        value: _vm.form.layer_id,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "layer_id",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.layer_id",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.group`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-active",
                        name: "active",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.onoff,
                        reduce: (option) => option.code,
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError("active", _vm.vScope),
                          },
                        ],
                        error: _vm.fnFirstError("active", _vm.vScope),
                        helpText: `${_vm.helpTranslateID}.active`,
                      },
                      model: {
                        value: _vm.form.active,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "active",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.active",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.active`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|integer|min_value:1",
                          expression: "'required|integer|min_value:1'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "number",
                        id: "input-order",
                        name: "order",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("order", _vm.vScope) },
                        ],
                        error: _vm.fnFirstError("order", _vm.vScope),
                        helpText: `${_vm.helpTranslateID}.order`,
                      },
                      model: {
                        value: _vm.form.order,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "order",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.order",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.order`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            !_vm.isLayer
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-collapse",
                            name: "collapse",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "collapse",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError("collapse", _vm.vScope),
                          },
                          model: {
                            value: _vm.form.collapse,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "collapse",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.collapse",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.collapse`)
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { class: [_vm.isLayer ? "col-sm-6" : "col-sm-8"] }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:3",
                          expression: "'required|min:3'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-name",
                        name: "name",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("name", _vm.vScope) },
                        ],
                        error: _vm.fnFirstError("name", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.name",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.name`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.isLayer
              ? _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.form.layer_id != null },
                              expression: "{required:form.layer_id!=null}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-tiled",
                            name: "tiled",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "tiled",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError("tiled", _vm.vScope),
                            helpText: `${_vm.helpTranslateID}.tiled`,
                          },
                          model: {
                            value: _vm.form.tiled,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "tiled",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.tiled",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(`${_vm.modelTranslateID}.tiled`)) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLayer
              ? _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.form.layer_id != null },
                              expression: "{required:form.layer_id!=null}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-visible",
                            name: "visible",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "visible",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError("visible", _vm.vScope),
                          },
                          model: {
                            value: _vm.form.visible,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "visible",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.visible",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.visible`)
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        id: "input-roles",
                        name: "roles",
                        disabled: _vm.readonlyFormItem,
                        filterable: false,
                        options: _vm.roles,
                        reduce: _vm.reduceRole,
                        multiple: true,
                        label: "role.name",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("roles") },
                        ],
                        error: _vm.fnFirstError("roles"),
                        helpText: `${_vm.pageID}.help.roles`,
                      },
                      model: {
                        value: _vm.form.roles,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "roles",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.roles",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.roles`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isLayer
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("h6", { staticClass: "font-weight-normal" }, [
                          _vm._v(
                            _vm._s(_vm.$t(`${_vm.modelTranslateID}.icon`))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              { staticClass: "img-icon img-thumbnail" },
                              [
                                _c("UploadMultipleImage", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "",
                                      expression: "''",
                                    },
                                  ],
                                  attrs: {
                                    disabled: _vm.readonlyFormItem,
                                    imageClass: "background-auto",
                                    name: "icon_layer",
                                    maxImage: 1,
                                    multiple: false,
                                    noOverlay: true,
                                    showImageLimitMessage: false,
                                    "data-vv-scope": _vm.vScope,
                                  },
                                  model: {
                                    value: _vm.icon_layer,
                                    callback: function ($$v) {
                                      _vm.icon_layer = $$v
                                    },
                                    expression: "icon_layer",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-8" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("h6", { staticClass: "font-weight-normal" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.attribution`)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.readonlyFormItem
                            ? [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.form.attribution),
                                  },
                                }),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "city-form-group",
                                    class: {
                                      "is-invalid": _vm.fnHasError(
                                        "attribution",
                                        _vm.vScope
                                      ),
                                    },
                                  },
                                  [
                                    _c("ckeditor", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "min:3",
                                          expression: "'min:3'",
                                        },
                                      ],
                                      attrs: {
                                        name: "attribution",
                                        disabled: _vm.readonlyFormItem,
                                        editor: _vm.cKEditor.editor,
                                        config: _vm.cKEditor.editorConfig,
                                        "data-vv-scope": _vm.vScope,
                                      },
                                      model: {
                                        value: _vm.form.attribution,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "attribution", $$v)
                                        },
                                        expression: "form.attribution",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.fnFirstError("attribution")
                                      ? _c(
                                          "small",
                                          {
                                            staticClass:
                                              "d-block invalid-feedback",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fnFirstError(
                                                  "attribution",
                                                  _vm.vScope
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("LayerLegend", {
                    staticClass: "mt-3 mt-sm-0",
                    attrs: {
                      files: _vm.legend_layer,
                      idPanel: _vm.pageID,
                      panelCfg: _vm.panelCfg,
                      baseTranslateID: _vm.pageID,
                      vScope: _vm.vScope,
                      readonlyForm: _vm.readonlyFormItem,
                    },
                    on: {
                      "update:files": function ($event) {
                        _vm.legend_layer = $event
                      },
                    },
                    model: {
                      value: _vm.form,
                      callback: function ($$v) {
                        _vm.form = $$v
                      },
                      expression: "form",
                    },
                  }),
                  _vm._v(" "),
                  _vm.enableFeatureinfo
                    ? _c("LayerFeatureinfo", {
                        staticClass: "mt-3",
                        attrs: {
                          idPanel: _vm.pageID,
                          panelCfg: _vm.panelCfg,
                          baseTranslateID: _vm.pageID,
                          vScope: _vm.vScope,
                          readonlyForm: _vm.readonlyFormItem,
                          resources: _vm.form.resources,
                          formats: _vm.lists.featureinfoformats,
                        },
                        model: {
                          value: _vm.form.feature_info,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "feature_info", $$v)
                          },
                          expression: "form.feature_info",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableFeatureable && _vm.form.featureable
                    ? _c("LayerFeatureableForm", {
                        staticClass: "mt-3",
                        attrs: {
                          idPanel: _vm.pageID,
                          panelCfg: _vm.panelCfg,
                          baseTranslateID: _vm.pageID,
                          vScope: _vm.vScope,
                          readonlyForm: _vm.readonlyFormItem,
                          resources: _vm.form.resources,
                          acls: _vm.lists.featureableacls,
                          subtypes: _vm.lists.featureablesubtypes,
                        },
                        model: {
                          value: _vm.form.featureable,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "featureable", $$v)
                          },
                          expression: "form.featureable",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("LayerResources", {
                    staticClass: "mt-3",
                    attrs: {
                      loadResources: _vm.loadResources,
                      idPanel: _vm.pageID,
                      panelCfg: _vm.panelCfg,
                      baseTranslateID: _vm.pageID,
                      vScope: _vm.vScope,
                      readonlyForm: _vm.readonlyFormItem,
                    },
                    model: {
                      value: _vm.form.resources,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "resources", $$v)
                      },
                      expression: "form.resources",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialColorPicker",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: !_vm.form.layer_id },
                              expression: "{required:!form.layer_id}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-icon_bg_color",
                            name: "icon_bg_color",
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "icon_bg_color",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "icon_bg_color",
                              _vm.vScope
                            ),
                            helpText: `${_vm.helpTranslateID}.icon_bg_color`,
                          },
                          model: {
                            value: _vm.form.icon_bg_color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "icon_bg_color",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.icon_bg_color",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.icon_bg_color`)
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-9" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: !_vm.form.layer_id },
                              expression: "{required:!form.layer_id}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            type: "text",
                            id: "input-icon",
                            name: "icon",
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "icon",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError("icon", _vm.vScope),
                            helpText: `${_vm.helpTranslateID}.icon`,
                          },
                          model: {
                            value: _vm.form.icon,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "icon",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.icon",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(`${_vm.modelTranslateID}.icon`)) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
          _vm._v(" "),
          _c("buttons-footer", {
            attrs: {
              enableButtons: !_vm.readonlyFormItem,
              cancelTitle: _vm.cancelTitle,
              submitTitle: _vm.submitTitle,
              isDisabled: _vm.isDisabled,
            },
            on: {
              save: _vm.onBeforeSaveItem,
              cancel: function ($event) {
                return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`, true)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }